/**
 * Utility functions for determining widget visibility and control visibility
 */

/**
 * Check if add/delete controls should be shown for a widget
 * This function matches the exact visibility logic used by widgets themselves
 */
export const shouldShowAddDeleteControls = (widget: any, isEditMode: boolean): boolean => {
  const widgetType = widget.type?.toLowerCase();
  
  // Popular Items - check for valid available menu items first
  if (widgetType?.includes('popular')) {
    const safeData = {
      selectedItemIds: widget.data?.selectedItemIds || [],
      menuData: widget.data?.menuData || [],
    };
    
    // First check: No menu data array
    if (!safeData.menuData || !Array.isArray(safeData.menuData)) {
      return false;
    }
    
    // Second check: Filter for valid available menu items
    const validMenuItems = safeData.menuData.filter((item: any) => {
      if (!item) return false;
      
      const isEnabled = item.is_enabled === true || item.is_enabled === "true";
      const hasInventory = item.inventory_status === true || item.inventory_status === "true";
      const isVerified = item.is_item_verified === true || item.is_item_verified === "true";
      
      return isEnabled && hasInventory && isVerified;
    });
    
    // Hide if no valid available items
    if (!validMenuItems || validMenuItems.length === 0) {
      return false;
    }
    
    if (!isEditMode) {
      // View mode: Also check if items are selected
      if (!safeData.selectedItemIds || safeData.selectedItemIds.length === 0) {
        return false;
      }
    }
    // Edit mode: Show controls only if valid menu items exist (already checked above)
    return true;
  }
  
  // Combo widgets - exact same logic as combo widgets
  if (widgetType?.includes('combo')) {
    const safeData = {
      combos: widget.data?.combos || [],
    };
    
    // First check: No combo data or not an array
    if (!safeData.combos || !Array.isArray(safeData.combos)) {
      return false;
    }
    
    // Check for valid combos (same logic as combo widgets use)
    const hasValidCombos = safeData.combos.some((combo: any) => {
      if (!combo) return false;
      const isEnabled = combo.is_enabled === true || combo.is_enabled === "true";
      
      if (!isEnabled) return false;
      
      // Check if combo has products
      const hasProducts = combo.products && Array.isArray(combo.products) && combo.products.length > 0;
      
      return hasProducts;
    });
    
    if (!hasValidCombos) {
      return false;
    }
    
    return true;
  }
  
  // All other widgets always show controls
  return true;
};
